export const ProductEnum = {
  PointOfSale: 13,
  Inventory: 14,
  SystemManagement: 15,
  StudentEligibility: 16,
  MenusProduction: 17,
  Financial: 18,
  Global: 20,
  Illuminate: 100,
};



// WEBPACK FOOTER //
// ./src/common/Constants/Enumeration/ProductEnum.js